import React, { useState } from "react";
import { format, addDays } from "date-fns";
import CommonFilterStructure from "../common-components/CommonFilterStructure";

const MemberTableFilters = ({
  user,
  allFilters,
  setAllFilters,
  searchFilterApplied,
  onClickSearch,
  onClickReset,
  onlySearch,
  MCUTSDate,
  onlyDateRanger,
  isDateRanger,
  isChekboxFilters,
  isShiftDropdown,
  trainerIdToGetShifts,
  clickedCard
}) => {
  const [openDateRanger, setOpenDateRanger] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);

  const handleDateRangeChange = (item) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    setAllFilters({
      ...allFilters,
      selectedStartDate: formattedStartDate,
      selectedEndDate: formattedEndDate,
    });
  };

  const clearDateRanger = () => {
    setOpenDateRanger(false);
    setRangeState(initialRangeState);
    setAllFilters({
      ...allFilters,
      selectedStartDate: "",
      selectedEndDate: "",
    });
  };

  return (
    <CommonFilterStructure
      from={"assigned-members"}
      decryptedText={user}
      setFilters={setAllFilters}
      filters={allFilters}
      searchFilterApplied={searchFilterApplied}
      onClickSearch={onClickSearch}
      onClickReset={onClickReset}
      openDateRanger={openDateRanger}
      handleDateRangeChange={handleDateRangeChange}
      setOpenDateRanger={setOpenDateRanger}
      rangeState={rangeState}
      clearDateRanger={clearDateRanger}
      onlySearch={onlySearch}
      MCUTSDate={MCUTSDate}
      onlyDateRanger={onlyDateRanger}
      isDateRanger={isDateRanger}
      isChekboxFilters={isChekboxFilters}
      isShiftDropdown={isShiftDropdown}
      trainerIdToGetShifts={trainerIdToGetShifts}
      clickedCard={clickedCard}
    />
  );
};

export default MemberTableFilters;
